import {mapMutations, mapActions, mapGetters} from "vuex";

//sections
import promoSection from '@/modules/home/section/promo/index.vue';
import togetherSection from '@/modules/home/section/together/index.vue';
import productSection from '@/modules/home/section/product/index.vue';
import newsSection from '@/modules/home/section/news/index.vue'
import {LATEST_PRODUCTS} from "../../store/action-types";

export default {
    name: "home",
    components: {
        promoSection,
        togetherSection,
        productSection,
        newsSection,
    },
    data() {
        return {}
    },
    created() {
        this.fetchHomeContent()
        // if (!this.isAuthenticated) {
        //     this.changeShowPopUpLogin(true)
        // }
    },
    computed: {
        ...mapGetters({
            latestProducts: 'home/productData',
            homeData: 'home/homeContent',
            isAuthenticated: 'auth/isAuthenticated'
        })
    },

    methods: {
        ...mapMutations({
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
        }),
        ...mapActions({
            fetchLatestProducts: 'home/LATEST_PRODUCTS',
            fetchHomeContent: 'home/HOME_CONTENT',
        })
    }
}
